import {
  FileText,
  Gavel,
  Clock,
  CheckCircle2,
  XCircle,
} from 'lucide-react';
import type { SourcingEvent } from '../../types';

interface TimelineTabProps {readonly event: SourcingEvent;}

export function TimelineTab({ event }: TimelineTabProps) {
  const formatDateTime = (dateStr: string) =>
    new Date(dateStr).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

  const events = [
    {
      date: event.createdAt,
      title: 'Event Created',
      description: `Created by ${event.createdByName}`,
      icon: FileText,
    },
  ];

  if (event.status === 'open' || event.status === 'evaluation' || event.status === 'awarded') {
    events.push({
      date: event.bidDeadline,
      title: 'Bidding Opened',
      description: 'Suppliers can now submit bids',
      icon: Gavel,
    });
  }

  if (event.status === 'evaluation') {
    events.push({
      date: event.updatedAt,
      title: 'Under Evaluation',
      description: 'Reviewing submitted bids',
      icon: Clock,
    });
  }

  if (event.status === 'awarded') {
    events.push({
      date: event.updatedAt,
      title: 'Bid Awarded',
      description: event.currentLowestBidder ? `Awarded to ${event.currentLowestBidder}` : 'Bid awarded',
      icon: CheckCircle2,
    });
  }

  if (event.status === 'cancelled') {
    events.push({
      date: event.updatedAt,
      title: 'Event Cancelled',
      description: 'This sourcing event was cancelled',
      icon: XCircle,
    });
  }

  events.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900">Activity Timeline</h3>
      <div className="space-y-4">
        {events.map((evt) => (
          <div key={`${evt.title}-${evt.date}`} className="flex gap-4">
            <div className="flex flex-col items-center">
              <div className="rounded-full bg-primary/10 p-2">
                <evt.icon className="h-4 w-4 text-primary" />
              </div>
            </div>
            <div className="pb-4">
              <p className="font-medium text-gray-900">{evt.title}</p>
              <p className="text-sm text-gray-500">{evt.description}</p>
              <p className="text-xs text-gray-400 mt-1">{formatDateTime(evt.date)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
